import { useState, useEffect } from 'react';
import { Loader2, AlertTriangle, CheckCircle2 } from 'lucide-react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Badge } from '../ui/badge';
import { diagnosticsAPI } from '../../lib/api';

export function BuildCommitCard() {
  const [loading, setLoading] = useState(true);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    diagnosticsAPI.buildInfo()
      .then(({ data: d }) => { if (!cancelled) setData(d); })
      .catch((err) => { if (!cancelled) setError(err.message || 'Failed to fetch build info'); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const isResolved = data && data.source !== 'fallback';

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Build Commit</CardTitle>
      </CardHeader>
      <CardContent>
        {loading && (
          <div className="flex items-center gap-2 text-sm text-muted-foreground">
            <Loader2 className="h-4 w-4 animate-spin" />
            Loading...
          </div>
        )}
        {error && (
          <div className="flex items-center gap-2 text-sm text-red-500">
            <AlertTriangle className="h-4 w-4" />
            {error}
          </div>
        )}
        {data && (
          <div className="space-y-2">
            <div className="flex items-center gap-3">
              {isResolved ? (
                <CheckCircle2 className="h-4 w-4 text-green-600 shrink-0" />
              ) : (
                <AlertTriangle className="h-4 w-4 text-yellow-500 shrink-0" />
              )}
              <code className="font-mono text-sm bg-muted px-2 py-0.5 rounded">
                {data.commit}
              </code>
              <Badge variant={isResolved ? 'default' : 'secondary'}>
                {data.source}
              </Badge>
            </div>
            {data.resolved_at && (
              <p className="text-xs text-muted-foreground">
                Resolved at {new Date(data.resolved_at).toLocaleString()}
              </p>
            )}
            {!isResolved && (
              <p className="text-xs text-muted-foreground">
                The build-time commit was not written. Check that the BUILD_COMMIT
                file or env var is set in the deploy pipeline.
              </p>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
